import React from 'react';
import { Container } from 'react-bootstrap';
import { ArrowUpRight } from 'react-bootstrap-icons';
import { HashLink } from 'react-router-hash-link';
import portrait from '../../Assets/Images/krish-mountains.jpeg';
import cats from '../../Assets/Images/cats.png';
import cube from '../../Assets/Images/personal/speedcube.jpeg';
import boardgame from '../../Assets/Images/personal/brass-game.jpeg';
import coffee from '../../Assets/Images/personal/coffee.jpeg';
import wrapped from '../../Assets/Images/personal/blackpink-wrapped.png';
import catToast from '../../Assets/Images/personal/cat-toast.webp';
import catFire from '../../Assets/Images/personal/cat-fire.webp';
import resume from '../../Assets/Documents/krish-resume.pdf';
import './About.css';

export const About = () => (
  <section className="page-section about-page">
    <Container>
      <div className="about-intro">
        <div className="about-intro-copy">
          <p className="about-eyebrow">About me</p>
          <h1>Hey, I’m Krish.</h1>
          <p className="about-lead">I grew up in Singapore, spent a few years in India, and moved to Canada for university.</p>
          <p>I'm studying Computer Science at Waterloo, specializing in AI, and graduating in April 2027.</p>
          <p className="about-academic-note">Co-op student · President’s Scholarship of Distinction</p>
          <div className="about-links">
            <HashLink className="text-link" to="/career#waterloo-education">My time at Waterloo <ArrowUpRight aria-hidden="true" /></HashLink>
            <a className="text-link" href={resume} target="_blank" rel="noreferrer">My résumé <ArrowUpRight aria-hidden="true" /></a>
          </div>
        </div>
        <figure className="portrait-wrap">
          <div className="portrait-photo"><img src={portrait} alt="me" width="3024" height="4032" /></div>
          <figcaption>this is me!</figcaption>
        </figure>
      </div>

      <section className="about-offline" aria-labelledby="outside-heading">
        <header className="about-section-heading">
          <h2 id="outside-heading">A few things I’m into.</h2>
          <p>A little of what I get up to outside work.</p>
        </header>
        <div className="interest-journal">
          <section className="interest interest-board" aria-labelledby="boardgames-heading">
            <figure className="interest-photo"><img src={boardgame} alt="My Brass: Birmingham game in progress, with industry tiles, routes, cards, and coins across the table." width="1368" height="1824" loading="lazy" /></figure>
            <div className="interest-copy">
              <p className="interest-label">Board games</p>
              <h3 id="boardgames-heading">Brass: Birmingham</h3>
              <p>Probably my favourite board game.</p>
            </div>
          </section>

          <section className="interest interest-cube" aria-labelledby="cubing-heading">
            <figure className="interest-photo"><img src={cube} alt="My blue, white, and orange speedcube on my desk, in front of my keyboard." width="1368" height="1824" loading="lazy" /></figure>
            <div className="interest-copy">
              <h3 className="interest-label" id="cubing-heading">Speedcubing</h3>
              <p className="cube-best"><strong>11.5</strong><span>seconds</span></p>
              <p>My personal best.</p>
            </div>
          </section>

          <section className="interest interest-coffee" aria-labelledby="coffee-heading">
            <figure className="interest-photo"><img src={coffee} alt="My attempt at latte art in a blue mug with a pink patterned rim." width="1368" height="1824" loading="lazy" /></figure>
            <div className="interest-copy">
              <p className="interest-label">Coffee</p>
              <h3 id="coffee-heading">I love coffee.</h3>
              <p>I'm pretty bad at latte art, though.</p>
            </div>
          </section>

          <section className="interest interest-music" aria-labelledby="music-heading">
            <figure className="interest-photo"><img src={wrapped} alt="BLACKPINK on my 2025 Spotify Wrapped top artist card." width="1080" height="1920" loading="lazy" /></figure>
            <div className="interest-copy">
              <p className="interest-label">K-pop, on repeat</p>
              <h3 id="music-heading">BLACKPINK</h3>
              <p>My top artist in 2025.</p>
            </div>
          </section>
        </div>
        <div className="about-also">
          <p className="about-also-label">Also in the mix</p>
          <p>I occasionally play badminton and pool. I watch a lot of TV, movies, and anime. Harry Potter, Pokémon, and Marvel are some of my favourites :p</p>
        </div>
        <p className="about-lately"><span>Lately</span> I'm getting into photography and hiking a bit, too.</p>
      </section>

      <section className="site-origin" aria-labelledby="site-origin-heading">
        <div className="site-origin-copy">
          <div className="site-origin-heading"><img src={cats} alt="" width="230" height="235" loading="lazy" /><h2 id="site-origin-heading">The cats stayed.</h2></div>
          <p>I built the original version of this website by hand a few years ago, and I'm still tinkering with it. I love cats, so there are a lot of them around here XD.</p>
        </div>
        <div className="cat-collection">
          <figure className="cat-snapshot cat-snapshot-toast"><img src={catToast} alt="A cartoon cat in sunglasses casually eating toast in front of an explosion." width="1440" height="1440" loading="lazy" /></figure>
          <figure className="cat-snapshot cat-snapshot-fire"><img src={catFire} alt="A tiny black cat sitting calmly in a sea of flames." width="1149" height="1440" loading="lazy" /></figure>
        </div>
      </section>
    </Container>
  </section>
);
